// Web Vitals reporting disabled for development
const reportWebVitals = () => {
  // Performance monitoring disabled
};

export default reportWebVitals;
